import { combineEpics } from 'redux-observable';
import refreshSelectionEpic from './refresh-selection';
import selectRowsEpic from './select-rows';

// @ts-expect-error - No overload matches this call
export default combineEpics(selectRowsEpic, refreshSelectionEpic);
